import { render, staticRenderFns } from "./RegistroEdit.vue?vue&type=template&id=156a2be3&"
import script from "./RegistroEdit.vue?vue&type=script&lang=js&"
export * from "./RegistroEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports